var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIraqIq = function SvgIraqIq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.66673H12V0H0V2.66673Z",
    fill: "#BD1032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.3335H12V2.66678H0V5.3335Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.00009H12V5.33353H0V8.00009Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20767 3.50865C7.19084 3.50024 7.17216 3.48639 7.16593 3.47798C7.15668 3.46512 7.16223 3.46479 7.20077 3.47518C7.26978 3.49348 7.31455 3.48606 7.35847 3.44946L7.39769 3.41714L7.44363 3.44039C7.46871 3.45259 7.49564 3.46133 7.50355 3.45935C7.52324 3.45424 7.56431 3.40231 7.56296 3.38467C7.56178 3.36241 7.5808 3.36785 7.58989 3.39208C7.60806 3.43973 7.58147 3.49447 7.53435 3.50667C7.51112 3.51244 7.49008 3.51029 7.45491 3.49842C7.41216 3.48391 7.40492 3.48391 7.38321 3.49991C7.33525 3.53634 7.26809 3.53948 7.20767 3.50865Z",
    fill: "#439B4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3786 3.35568C7.36177 3.33475 7.34174 3.25594 7.34797 3.23648C7.35403 3.21967 7.35992 3.21621 7.37524 3.22115C7.40267 3.22923 7.40923 3.24786 7.40486 3.31068C7.40166 3.36145 7.39409 3.37497 7.3786 3.35568Z",
    fill: "#439B4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36621 3.29825C5.36066 3.3365 5.43555 3.43163 5.46938 3.44894C5.44649 3.459 5.41788 3.45438 5.39684 3.46576C5.27903 3.581 4.84952 3.99119 4.77093 4.08945C5.00335 4.0939 5.26102 4.08615 5.47897 4.07659C5.47897 3.92194 5.62859 3.91387 5.72873 3.85765C5.7804 3.93711 5.90983 3.93101 5.92598 4.05071C5.92598 4.19414 5.92632 4.41012 5.92632 4.56592H3.94053C3.90569 4.71693 3.76633 4.83234 3.57245 4.78502C3.63253 4.72353 3.73351 4.70259 3.7697 4.61752C3.80016 4.43171 3.70877 4.31713 3.6497 4.21145C3.74731 4.17666 3.76246 4.16793 3.86176 4.10231C3.79191 4.31037 4.04353 4.28746 4.22984 4.28267C4.23606 4.21211 4.23253 4.12869 4.17733 4.11847C4.24852 4.09291 4.2608 4.08434 4.37441 3.98954V4.26981C4.81822 4.26981 5.29687 4.26652 5.74977 4.26652C5.74977 4.17897 5.7735 4.03818 5.70248 4.03818C5.63516 4.03818 5.69945 4.21821 5.64694 4.21821H4.58478C4.58478 4.17963 4.58394 4.09852 4.58394 4.04015C4.62888 3.99597 4.62366 3.99993 4.93098 3.69855C4.96195 3.66854 5.17754 3.47763 5.36621 3.29825Z",
    fill: "#439B4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02065 3.2916C8.09487 3.3305 8.15344 3.38458 8.24449 3.4075C8.23372 3.44426 8.2004 3.45877 8.19165 3.49768V4.28344C8.29313 4.3052 8.31451 4.24898 8.36247 4.21897C8.3756 4.3446 8.45756 4.46792 8.45453 4.56668H8.02065V3.2916Z",
    fill: "#439B4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.068 4.25536C7.08938 4.28685 7.16208 4.28619 7.15872 4.23343C7.14626 4.19007 7.05084 4.2064 7.068 4.25536ZM7.44214 3.71245C7.44214 3.71245 7.59984 3.58171 7.59984 3.57693V4.26245H7.71361C7.71361 4.00097 7.71024 3.73603 7.71024 3.49318C7.75636 3.44817 7.84674 3.38272 7.86946 3.33705V4.56482C7.54884 4.56482 6.95171 4.56515 6.87244 4.56515C6.85796 4.31043 6.85527 4.04631 7.15872 4.10302V3.99899C7.14913 3.98135 7.1328 4.00361 7.12876 3.98036C7.17706 3.93305 7.19322 3.92118 7.32382 3.8094C7.32382 3.94393 7.32601 4.26212 7.32601 4.26212H7.44113C7.44113 4.26212 7.44214 3.72977 7.44214 3.71245Z",
    fill: "#439B4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18257 4.65176C4.21606 4.65176 4.24333 4.67847 4.24333 4.71161C4.24333 4.74442 4.21606 4.77129 4.18257 4.77129C4.14908 4.77129 4.12181 4.74442 4.12181 4.71161C4.12181 4.67847 4.14908 4.65176 4.18257 4.65176Z",
    fill: "#439B4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06081 3.29289C6.13504 3.3318 6.1936 3.38587 6.28432 3.40879C6.27388 3.44556 6.24056 3.46006 6.23181 3.49897V4.28473C6.3333 4.30649 6.35433 4.25027 6.40264 4.22027C6.41576 4.3459 6.49773 4.46922 6.4947 4.56797H6.06081V3.29289Z",
    fill: "#439B4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    fill: "white"
  })))));
};

export default SvgIraqIq;